module.exports = __webpack_public_path__ + "static/media/researcher_placeholder.f262b04b.png";